import React from 'react';
import { Card, CardContent, Typography, Checkbox, Box, ButtonBase } from '@mui/material';

export default function ButtonWithCheckbox({ displayKey, checked, lastUpdated, by, onClickHandler, showCaption = false, isInactive = false }) {
  
  const dateLabel = new Date(lastUpdated);
  lastUpdated = dateLabel.toLocaleString('en-GB')
  return (
    <div
      style={{
        width: 200,
        display: 'flex',
        flexDirection: 'column', // Ensure vertical stacking
        alignItems: 'center',
      }}
    >
      <ButtonBase
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          backgroundColor: 'white !important',
        }}
        onClick={onClickHandler}
      >
        <Card
          sx={{
            width: '100%',
            height: 80,
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            boxShadow: 3,
            backgroundColor: isInactive ? '#f5f5f5' : 'white',
            '&:hover': {
              boxShadow: 6,
              transform: 'scale(1.02)',
              transition: 'all 0.2s ease-in-out',
            },
          }}
        >
          <CardContent >
            <Typography
              variant="h6"
              component="div"
              align="center"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: 'clamp(12px, 2.5vw, 18px)', // Responsive font size
                maxWidth: '100%',
                display: '-webkit-box',
                WebkitLineClamp: 2, // Limits to 2 lines before truncating
                WebkitBoxOrient: 'vertical',
                color: isInactive ? '#888' : 'inherit',
              }}
            >
              {displayKey} {isInactive && '(Read Only)'}
            </Typography>
          </CardContent>

          {/* Checkbox positioned at bottom-left */}
          <Box sx={{ position: 'absolute', bottom: 0, left: 8, }}>
            <Checkbox checked={checked} disabled 
              sx={{
                color: isInactive ? '#888' : 'blue',
                '&.Mui-checked': {
                  color: isInactive ? '#888' : 'blue',
                },
              }}/> {/* Disabled to prevent user interaction */}
          </Box>
        </Card>
      </ButtonBase>
      {
        showCaption ?
            <>
                {/* Additional Info outside ButtonBase */}
                <Typography
                    variant="caption"
                    display="block"
                    sx={{ marginTop: 1, textAlign: 'center', color: isInactive ? '#888' : 'inherit' }} // Adds margin above the text
                >
                    {`Last Updated: ${lastUpdated}`}
                </Typography>
                <Typography
                    variant="caption"
                    display="block"
                    sx={{ textAlign: 'center', color: isInactive ? '#888' : 'inherit' }} // Center-aligns the text
                >
                    {`By: ${by}`}
                </Typography>
            </>
            :
            null
      }

    </div>
  );
}
